import { useState } from 'react';

export const useImageSize = (url) => {
  const [urlResized, setRrlResized] = useState(`${url}&imwidth=2400`);

  return {
    urlResized,
    setRrlResized,
  };
};
